"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSTransferModuleComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../../shared/services/account.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const generic_content_service_1 = require("./../../shared/services/generic.content.service");
const _ = require("underscore");
class CSTransferModuleComponent {
    constructor(modalService, accountService, genericContentService) {
        this.modalService = modalService;
        this.accountService = accountService;
        this.genericContentService = genericContentService;
    }
    ngOnInit() {
        this.getSubscriptionDetails();
        this.accountType = 'existing';
        this.count = 0;
    }
    getSubscriptionDetails(cacheResponse) {
        this.accountService.getAccountDetails(cacheResponse).subscribe((accountInfo) => {
            this.subscriptions = accountInfo.subscription;
            this.loading = false;
        }, (err) => {
            this.error = err;
            this.loading = false;
        });
    }
    setAccountType(accountType) {
        this.accountType = accountType;
    }
    transferLines() {
        this.arrayList = [];
        this.subscriptions.forEach((item) => {
            if (item.checked) {
                this.arrayList.push(item);
            }
        });
        if (_.find(this.arrayList, function (sub) {
            return sub.primarySubOnAccount === true;
        }) !== undefined) {
            this.genericContentService.getGenericContent('genericInstructionalprimaryLineTransfer').subscribe((genericContent) => {
                this.genericContentData = genericContent.contentText;
                this.open(this.primaryAccountMessageTemplate);
            }, (err) => {
                this.error = err;
            });
        }
    }
    getCheckedCheckboxes() {
        this.count = 0;
        this.subscriptions.forEach((item) => {
            if (item.checked) {
                this.count++;
            }
        });
    }
    redirctToAccountSetting() {
        this.modelRef.close();
        location.href = '/my_account/personal/#/prepaid/account-settings';
    }
    open(content, options = { size: 'lg', windowClass: 'supend-info' }) {
        this.modelError = null;
        this.modelRef = this.modalService.open(content, options);
    }
}
exports.CSTransferModuleComponent = CSTransferModuleComponent;
//# sourceMappingURL=transferModule.component.js.map